<script setup lang="ts">
import SamplesIcon from '~/components/ui/icons/SamplesIcon.vue';
import BasketIcon from '~/components/ui/icons/BasketIcon.vue';
import { RoleConstants } from '~/types/global';

defineProps<{
  samples: any;
  basket: any;
}>();

const { hasPermission } = usePermissions();
const canCreateOrders =  hasPermission(RoleConstants.Orders.CreateOrders);
</script>

<template>
  <div
    class="relative flex flex-row gap-5 rounded-tl-3xl bg-anti-flash-white-600 px-8 py-4 pr-0 text-xs text-stormcloud"
    v-if="canCreateOrders"
  >
    <nuxt-link
      class="flex flex-row items-center justify-between gap-2 font-medium uppercase transition-colors hover:text-gunmetal"
      to="/samples"
    >
      <SamplesIcon />
      <span class="hidden font-heading tracking-heading md:block">Samples</span>
      <div
        v-if="samples"
        class="mb-auto hidden h-[13px] flex-row items-center justify-center rounded-3xl bg-stormcloud px-1 pb-[1px] text-[10px] text-white md:flex"
      >
        <span>{{ samples }}</span>
      </div>
    </nuxt-link>
    <nuxt-link
      class="flex flex-row items-center justify-between gap-2 font-medium uppercase transition-colors hover:text-gunmetal"
      to="/basket"
    >
      <BasketIcon />
      <span class="hidden font-heading tracking-heading md:block">Basket</span>
      <div
        v-if="basket"
        class="mb-auto hidden h-[13px] flex-row items-center justify-center rounded-3xl bg-stormcloud px-1 pb-[1px] text-[10px] text-white md:flex"
      >
        <span>{{ basket }}</span>
      </div>
    </nuxt-link>
    <div class="absolute left-full top-0 h-full w-screen bg-anti-flash-white-600" />
  </div>
</template>
